import useAppState from '../../state/appState';
import { FormConfig } from '@topdanmark-onlinesolutions/claim-form-types';

export const ConditionalBaseBuilder = () => {
    const formConfig = useAppState((state) => state.formConfig);

    if (!formConfig) {
        return <></>;
    }

    let s = conditionalBaseStart();
    s += conditionalBaseCases(formConfig);
    s += conditionalBaseEnd();

    return <pre>{s}</pre>;
};

// Used to create the base conditional tree
export const conditionalBaseCases = (formConfig: FormConfig) => {
    let s = '';

    formConfig.pages.forEach((page, i) => {
        const pageIdCur = page.pageId;
        const elements = page.elements;

        const pageNext = formConfig.pages[i + 1];

        s += `
        case '${pageIdCur}':
        `;

        if (pageNext) {
            const pageIdNext = pageNext.pageId;

            // Add all elementIds on the current page
            elements.forEach((element) => {
                const elementId = element.elementId;

                s += `
                if (getValueOrDefault(formConfig, formValues, '${elementId}').value === 'XXX')
                    nextPage = '${pageIdNext}';
                }
                else {
                    nextPage = '${pageIdNext}';
                }
            `;
            });
        } else {
            s += `
                nextPage = undefined;
            `;
        }

        s += `break;
        `;
    });

    return s;
};

const conditionalBaseStart = () => {
    return `
    import { FormValues } from '../types/form-values';
    import { NextFunction } from '../types/conditional-page';
    import { FormConfig } from '../types/form-config';
    import { getValueOrDefault } from '../components/values/Get';

    export const getNextPage: NextFunction = async (
        curPageId: string,
        formConfig: FormConfig,
        formValues: FormValues
    ) => {
        let nextPage: string | undefined = '';

        switch (curPageId) {
`;
};

const conditionalBaseEnd = () => {
    return `
            default:
                throw new Error('Unknown page: ' + curPageId);
        }

        return nextPage;
    };
    `;
};
